/**
 * @fileoverview Omni-bar input for quickly adding tasks with tags.
 */
import TaskInputQuickInline from '@/features/tasks/components/forms/TaskInputQuickInline';
import TaskInputQuickOmni from '@/features/tasks/components/forms/TaskInputQuickOmni';
import { useTaskInputQuick } from '@/features/tasks/components/forms/useTaskInputQuick';

const TaskInputQuick = ({
  className = '',
  sx = {},
  isInline = false,
  onTaskAdd = (..._args) => {},
  onBlur = () => {},
  placeholder,
  inputId = 'quick-add-input',
  onTaskAdded,
  disableEmptyNavigate = false,
  showTokenPreview = true,
  onInputFocus,
  onInputBlur,
  onInputChange,
  onInputEscape,
}) => {
  const state = useTaskInputQuick({
    onTaskAdd,
    onBlur,
    placeholder,
    onTaskAdded,
    disableEmptyNavigate,
    onInputChange,
    onInputEscape,
  });

  if (isInline) {
    return (
      <TaskInputQuickInline
        fieldPlaceholder={state.fieldPlaceholder}
        inputValue={state.inputValue}
        setInputValue={state.setInputValue}
        handleInlineKeyDown={state.handleInlineKeyDown}
        handleInlineBlur={state.handleInlineBlur}
        showTokenPreview={showTokenPreview}
        parsedPreview={state.parsedPreview}
      />
    );
  }

  return (
    <TaskInputQuickOmni
      className={className}
      sx={sx}
      inputId={inputId}
      fieldPlaceholder={state.fieldPlaceholder}
      inputValue={state.inputValue}
      errorMessage={state.errorMessage}
      onInputFocus={onInputFocus}
      onInputBlur={onInputBlur}
      handleOmniChange={state.handleOmniChange}
      handleQuickAddKeyDown={state.handleQuickAddKeyDown}
      disableEmptyNavigate={disableEmptyNavigate}
      handleQuickAddButtonClick={state.handleQuickAddButtonClick}
      trailingActionLabel={state.trailingActionLabel}
      showTokenPreview={showTokenPreview}
      parsedPreview={state.parsedPreview}
    />
  );
};

export default TaskInputQuick;
